import { useActiveCompany } from '~/hooks/useActiveCompany';
import { UserRole } from '~/types/company';

export const useHasAllowedRole = (allowedRoles: UserRole[]) => {
  const company = useActiveCompany();
  return allowedRoles.includes(company.userRole);
};

export const useCanAccessFeqCredentialSettings = () => {
  return useHasAllowedRole([UserRole.ENTREPRENEUR, UserRole.ADVISOR]);
};
